import React, { memo, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { KeyMapKeys } from '@locales/lokalise/keyMap';

interface ITableFootnote {
  icon?: ReactNode;
  hint: string;
}
export const TableFootnote = memo(({ icon, hint }: ITableFootnote): JSX.Element => {
  const { i18n } = useTranslation();

  return (
    <div className="table__footnote">
      {icon || ''}
      <p>{i18n.t(hint as KeyMapKeys)}</p>
    </div>
  );
});

TableFootnote.displayName = 'TableFootnote';
